import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next, useTranslation } from 'react-i18next';
import koreanTranslation from '@/common/resource/translation/ko.json';
import landingKo from '@/common/resource/translation/landing/ko.json';
import landingEn from '@/common/resource/translation/landing/en.json';
import { setDefaultOptions } from 'date-fns';
import { enUS, ko } from 'date-fns/locale';

export enum SupportLang {
  Korean = 'ko',
  English = 'en',
}
// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  [SupportLang.Korean]: {
    translation: koreanTranslation,
    landing: landingKo,
  },
  [SupportLang.English]: {
    translation: koreanTranslation,
    landing: landingEn,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    //lng: SupportLang.Korean, // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    fallbackLng: SupportLang.Korean,
    detection: { order: ['sessionStorage', 'localStorage', 'navigator'] },
    ns: ['translation', 'landing'],
    defaultNS: 'translation',
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

i18n.on('initialized', (options) => {
  setDefaultOptions({
    locale: options.lng === SupportLang.Korean ? ko : enUS,
  });
});
i18n.on('languageChanged', (lng) => {
  setDefaultOptions({
    locale: lng === SupportLang.Korean ? ko : enUS,
  });
});

export default i18n;
export * from 'react-i18next';

export const useLandingTranslation = () => useTranslation('landing');
